import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUiTranslation } from "../../../i18n";
import { Label } from "../../../components/base";
import { formatDateOnly, parseDateOnly } from "../../../lib/date";
import { InteractionRequestDatePicker } from "./InteractionRequestDatePicker";
import { FieldDescription } from "../FieldDescription";
export const DateField = ({ field, value, disabled, error, onChange, }) => {
    const { t } = useUiTranslation();
    const date = parseDateOnly(value);
    const defaultPlaceholder = t("form.pickDate");
    const placeholder = field.placeholder ||
        (defaultPlaceholder === "form.pickDate"
            ? "Pick a date"
            : defaultPlaceholder);
    const handleSelect = (d) => {
        onChange?.(d ? formatDateOnly(d) : "");
    };
    return (_jsxs("div", { className: "space-y-1", children: [_jsxs(Label, { className: "text-xs", children: [field.question, " ", field.required && _jsx("span", { className: "text-red-500", children: "*" })] }), _jsx(FieldDescription, { ...field }), _jsx(InteractionRequestDatePicker, { date: date, onSelect: handleSelect, placeholder: placeholder, disabled: disabled, className: error ? "border-red-500 focus-visible:ring-red-500" : undefined }), error && _jsx("p", { className: "text-xs text-red-500", children: error })] }));
};
export const validateDateField = (field, value, t) => {
    if (!field.required)
        return undefined;
    const str = value === undefined || value === null ? "" : String(value);
    if (str.trim() === "") {
        return t("form.validation.required");
    }
    return undefined;
};
//# sourceMappingURL=DateField.js.map